/** @jsxImportSource react */
function TexasDisclosure() {
  return (
    <div>
      Seniorly helps families explore senior living options. If you move into a
      community we referred, we may be paid by that community—usually 20% to
      100% of your first month’s rent and care. We do not provide medical or
      personal care advice.
      <br />
      You are not required to use our services, and you may contact communities
      directly. Our referral list may not include all communities in your area
      that match your preferences. We consider your needs and goals when making
      recommendations; cost is never the only factor we use.
      <br />
      You may stop using our services at any time by letting us know in writing.
      If you stop, we won’t be paid for any future move-in unless (1) it’s to a
      place we referred before your notice, or (2) you contact us again before
      moving.
      <br />
      By continuing, you acknowledge you’ve received and understood this
      disclosure.
    </div>
  );
}

export default TexasDisclosure;
